import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";

import { SelectField, TextAutocompleteField, TextField } from "components";
import { FormGridFieldItem } from "components/FormComponents/FormGridItems";
import { RELEASE_ROLES_OPTIONS, RELEASE_TYPES_OPTIONS } from "constants/release";
import { ApiKeyFields, ContributorsForm } from "types";

import { FORM_LABELS } from "./constants";
import { ReleaseRole } from "./types";

const ContributorFormFields = () => {
  const { watch, control, setValue } = useFormContext<ContributorsForm>();

  const [roleWatch] = watch([ApiKeyFields.role]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === ApiKeyFields.role) setValue(ApiKeyFields.type, "", { shouldValidate: true });
    });
    return () => subscription.unsubscribe();
  }, [setValue]);

  const typeOptions = useMemo(() => {
    if (!roleWatch || !(roleWatch in RELEASE_TYPES_OPTIONS)) return [];
    return RELEASE_TYPES_OPTIONS[roleWatch as ReleaseRole];
  }, [roleWatch]);

  return (
    <>
      <FormGridFieldItem fieldName={ApiKeyFields.artistName} label={FORM_LABELS[ApiKeyFields.artistName]}>
        {(field) => <TextField {...field} control={control} />}
      </FormGridFieldItem>
      <FormGridFieldItem fieldName={ApiKeyFields.role} label={FORM_LABELS[ApiKeyFields.role]}>
        {(field) => <SelectField {...field} control={control} options={RELEASE_ROLES_OPTIONS} />}
      </FormGridFieldItem>
      <FormGridFieldItem fieldName={ApiKeyFields.type} label={FORM_LABELS[ApiKeyFields.type]}>
        {(field) => (
          <TextAutocompleteField {...field} control={control} options={typeOptions as string[]} disabled={!roleWatch} />
        )}
      </FormGridFieldItem>
    </>
  );
};

export default ContributorFormFields;
